// extracted by mini-css-extract-plugin
export default {"container":"aZ-z","title":"bZ-z","link":"cZ-z"};